const EvaluationPeriodTabs = () =>
  import(
    "@/features/dep/evaluation_periods/home/presentation/views/EvaluationPeriodsTabs.vue"
  );
const DepPeriodSetSection = () =>
  import("@/components/evaluation/configuration/DepPeriodSetSection.vue");
const DepVisibilitySection = () =>
  import("@/components/evaluation/configuration/DepVisibilitySection");
const DepAttendanceListSection = () =>
  import("@/components/evaluation/configuration/DepAttendanceListSection");
const DepSubjectsSection = () =>
  import("@/components/evaluation/configuration/DepSubjectsSection");

export const evaluationPeriodRoutes = [
  {
    path: "/evaluation/reportcard-config",
    component: EvaluationPeriodTabs,
    children: [
      {
        name: "period-sets",
        path: "/",
        component: DepPeriodSetSection,
      },
      {
        name: "visibility",
        path: "visibility",
        component: DepVisibilitySection,
      },
      {
        name: "attendance-list",
        path: "attendance-list",
        component: DepAttendanceListSection,
      },
      {
        name: "subjects",
        path: "subjects",
        component: DepSubjectsSection,
      },
    ],
  },
];
